$(document).on('change', '.js_discount_mode', function(e) {
  if ($(this).val() == 0) {
    $('.js_wrapper_mode_range').show();
    $('.js_wrapper_mode_limit').hide();

    $('.js_mode_range').attr("disabled", false);
    $('.js_mode_limit').attr("disabled", "disabled");
  } else {
    $('.js_wrapper_mode_range').hide();
    $('.js_wrapper_mode_limit').show();

    $('.js_mode_range').attr("disabled", "disabled");
    $('.js_mode_limit').attr("disabled", false);
  }
});

$(document).on('change', '.js_itemable_type', function(e) {
  changeItemable();
});

$(document).on('change', '.js_is_all', function(e) {
  changeItemable();
});

function changeItemable() {
  if ($('.js_is_all').is(":checked")) {
    $('.js_wrapper_playlist').hide();
    $('.js_wrapper_plan_package').hide();

    $('.js_playlist').attr("disabled", "disabled");
    $('.js_plan_package').attr("disabled", "disabled");
  } else {
    if ($('.js_itemable_type').val() == 'Playlist') {
      $('.js_wrapper_playlist').show();
      $('.js_wrapper_plan_package').hide();

      $('.js_playlist').attr("disabled", false);
      $('.js_plan_package').attr("disabled", "disabled");
    } else {
      $('.js_wrapper_playlist').hide();
      $('.js_wrapper_plan_package').show();

      $('.js_playlist').attr("disabled", "disabled");
      $('.js_plan_package').attr("disabled", false);
    }
  }
}
